// YadsScheduleIngestionAction.js
import {
  POST_YADS_SCHEDULE_REQUEST,
  POST_YADS_SCHEDULE_SUCCESS,
  POST_YADS_SCHEDULE_FAILURE,
  POST_YADS_SCHEDULE_RESET,
} from '../../../Constants/actionTypes';

import { postYadsScheduleIngestion } from '../../../Constants/apiService';

export const postYadsScheduleRequest = () => ({ type: POST_YADS_SCHEDULE_REQUEST });
export const postYadsScheduleSuccess = (data) => ({ type: POST_YADS_SCHEDULE_SUCCESS, payload: data });
export const postYadsScheduleFailure = (err) => ({ type: POST_YADS_SCHEDULE_FAILURE, payload: err });
export const postYadsScheduleReset   = () => ({ type: POST_YADS_SCHEDULE_RESET });

export const startYadsScheduleIngestion = (payload) => {
  return async (dispatch, getState) => {
    dispatch(postYadsScheduleRequest());
    const accessToken = getState().auth.accessToken;

    try {
      const res = await postYadsScheduleIngestion(payload, accessToken);
      dispatch(postYadsScheduleSuccess(res));
    } catch (error) {
      const msg = error.message?.includes("fetch")
        ? "Unable to schedule ingestion. Please try again."
        : error.message;
      dispatch(postYadsScheduleFailure(msg));
    }
  };
};
